export default {
	"admin": "Админ",
	"client": "Клиент",
	"mechanic": "Механик",
	"consultant": "Консультант",
	"diagnosis": "Диагностика"
}
